import callApi from "./callApi";
import callApiSettlement from "./callApiSettlement";
import callApiRiwayatPembayaran from "./callApiRiwayatPembayaran";

export default {
    ...callApi,
    ...callApiSettlement,
    ...callApiRiwayatPembayaran,
    setSelectedPosted: ({ commit }, payload) => {
        commit("setSelectedPosted", payload);
    },
    setNominalPosted: ({ commit }, payload) => {
        commit("setNominalPosted", payload);
    },
    setChange: ({ commit }, payload) => {
        commit("setChange", payload);
    },
    resetPosted: ({ commit }) => {
        commit("resetPosted");
    },
    resetResponse: ({ commit }) => {
        commit("resetResponse");
    },
    resetListMesin: ({ commit }) => {
        commit("resetListMesin");
    },
    resetDataMesin: ({ commit }) => {
        commit("resetDataMesin");
    },
    resetListSettlementEdc: ({ commit }) => {
        commit("resetListSettlementEdc");
    },
    resetDetailMesin: ({ commit }) => {
        commit("setDetailMesin", {});
    },
    setFetching: ({ commit }, payload) => {
        commit("setFetching", payload);
    },
    setPosted: ({ commit }, payload) => {
        commit("setPosted", payload);
    },
    resetPagination: ({ commit }) => {
        commit("resetPagination");
    },
    resetPaginationSettlement: ({ commit }) => {
        commit("resetPaginationSettlement");
    },
    resetPaginationRiwayatPembayaran: ({ commit }) => {
        commit("resetPaginationRiwayatPembayaran");
    },
    toogleDisplayCard: ({ commit }, payload) => {
        commit("toogleDisplayCard", payload);
    },
    setLoadMore: ({ commit }, payload) => {
        commit("setLoadMore", payload);
    },
    setLastItemToView: ({ commit }, payload) => {
        commit("setLastItemToView", payload);
    },
    toggleItem: ({ commit }, payload) => {
        commit("toggleItem", payload);
    },
    toggleCheckParent: ({ commit }, payload) => {
        commit("toggleCheckParent", payload);
    },
		toggleSelectAllPembayaran: ({ commit }, payload) => {
			commit("toggleSelectAllPembayaran", payload);
	},
    resetListRiwayatPembayaran: ({ commit }) => {
        commit("resetListRiwayatPembayaran");
    },
    toggleExporting: ({ commit }, payload) => {
        commit("setExporting", payload);
    },
    setMinimized: ({ commit }, payload) => {
        commit("setMinimized", payload);
    },
    setMultiple: ({ commit }, payload) => {
        commit("setMultiple", payload);
    },
    setData: ({ commit }, payload) => {
        commit("setData", payload);
    },
    setDataLength: ({ commit }, payload) => {
        commit("setDataLength", payload);
    },
    setExportProgress: ({ commit }, payload) => {
        commit("setExportProgress", payload);
    },
    resetExportData: ({ commit }) => {
        commit("resetExportData");
    },
};
